import HeadingH4 from "./HeadingH4";

export default HeadingH4;
